export const INTERCOM_APP_ID = "nygd8jj7";
export const CUSTOM_LAUNCHER_ELEMENT_ID = "ss-intercom-launcher";
export const CUSTOM_LAUNCHER_SELECTOR = `#${CUSTOM_LAUNCHER_ELEMENT_ID}`;
